import type React from 'react';

/**
 * React's `CSSProperties` has no index signature, so custom properties need a cast. This is the
 * one place that cast lives — per-bar geometry is written as `--bar-*` on the row element, which
 * is what lets a zoom change be one variable write instead of a re-render of every bar.
 */
export const cssVars = (vars: Record<string, string | number>): React.CSSProperties =>
  vars as React.CSSProperties;
